<script lang="ts">
	import { navigating } from '$app/stores';
	import { Cross, Search as SearchIcon } from '@icons';
	import { trackDeletedSearch } from '@tools/tracking/TrackSearch';

	let {
		query = $bindable(''),
		// @ts-expect-error why??
		results = $bindable([]),
		placeholder = 'Søg',
		type,
		collapsible = false,
		collapsed = $bindable(true),
		// @ts-expect-error why??
		loading = $bindable(false)
	}: {
		query?: string;
		placeholder?: string;
		results: any[];
		type?: string;
		collapsible?: boolean;
		collapsed?: boolean;
		loading?: boolean;
	} = $props();

	let value = $state('');
	let timer: number = 0;
	let input: HTMLInputElement;
	let focused = $state(false);
	let isDeleting = $state(false);

	const keydown = () => {
		if (value.length < query.length) {
			if (!isDeleting) {
				trackDeletedSearch(value);
			}
			isDeleting = true;
		} else {
			isDeleting = false;
		}

		clearTimeout(timer);
		timer = window.setTimeout(() => {
			query = value.length > 2 ? value : '';
		}, 500);
	};

	$effect(() => {
		const unsub = navigating.subscribe((data) => {
			if (!data) {
				value = '';
				query = '';
				results = [];
			}
		});

		return () => {
			unsub();
		};
	});

	$effect(() => {
		if (query.length > 2) {
			loading = true;
			fetch(`/api/v2/search?q=${query}${type ? `&type=${type}` : ''}`)
				.then((r) => r.json())
				.then((res) => {
					if (res.data) results = res.data;
					else results = [];
				})
				.catch(console.error)
				.finally(() => {
					loading = false;
				});
		} else {
			results = [];
			loading = false;
		}
	});

	$effect(() => {
		if (focused || query.length > 0) {
			collapsed = false;
		} else {
			collapsed = true;
		}
	});
</script>

<div class="SearchInput input:string">
	<input
		class="input:string"
		class:collapsible
		class:collapsed
		type="text"
		name="search"
		id="search"
		{placeholder}
		bind:this={input}
		bind:value
		onkeydown={keydown}
		onfocus={() => (focused = true)}
		onblur={() => (focused = false)}
		autocomplete="off"
	/>
	{#if value.length > 0}
		<button
			aria-label="Clear search"
			onclick={() => {
				value = '';
				query = '';
				input.focus();
			}}
		>
			<Cross />
		</button>
	{:else}
		<label for="search" tabindex="-1">
			<SearchIcon />
		</label>
	{/if}
</div>

<style lang="scss">
	div {
		display: flex;
		align-items: stretch;
		overflow: hidden;
		padding: 0;

		&:focus-whitin {
			outline: 2px solid black;
		}
	}

	input {
		padding-right: calc($gap5 * 2 + 1.25em);
		margin-right: calc($gap5 * -2 - 1.25em);
		flex: 1 1 auto;
		color: inherit;
		background-color: inherit;

		&.collapsible {
			transition:
				width $transition,
				padding-left $transition;

			&::placeholder {
				color: $colorNavBackground;
				opacity: 1;
				transition: opacity $transition;
			}

			&:placeholder-shown:not(:focus) {
				width: 0;
				padding-left: 0;
				cursor: pointer;

				&::placeholder {
					opacity: 0;
				}
			}
		}
	}

	button,
	label {
		display: flex;
		place-items: center;
		cursor: pointer;
		padding: 0 1em;

		@include md {
			padding: 0 $gap5;
		}

		:global(svg) {
			height: 1.25em;
			width: 1.25em;
		}

		&:focus-visible {
			outline: none;
		}
	}

	label {
		pointer-events: none;
	}
</style>
